import type { DateRange } from 'react-day-picker';

import dayjs from 'dayjs';

// Lib
import {
    CURRENT_MONTH,
    CURRENT_QUARTER,
    CUSTOM,
    LAST_3_MONTHS,
    LAST_7_DAYS,
    LAST_30_DAYS,
    PREVIOUS_MONTH,
    PREVIOUS_WEEK
} from '@/lib/periods';

export type DatepickerPeriodsCompetitorsType =
    | typeof PREVIOUS_WEEK
    | typeof LAST_7_DAYS
    | typeof PREVIOUS_MONTH
    | typeof LAST_30_DAYS
    | typeof LAST_3_MONTHS
    | typeof CURRENT_QUARTER
    | typeof CUSTOM
    | typeof CURRENT_MONTH;

export type DatepickerCompetitorsType = {
    date: DateRange;
    period: DatepickerPeriodsCompetitorsType;
};

const datepickerCompetitorsLocalStorageKey = 'local-storage-datepicker-competitors';

export function setDatepickerCompetitorsLocalStorage(datepickerData: DatepickerCompetitorsType) {
    window.localStorage.setItem(
        datepickerCompetitorsLocalStorageKey,
        JSON.stringify(datepickerData)
    );
}

export function getDatepickerCompetitorsLocalStorage(): DatepickerCompetitorsType {
    if (!window.localStorage.getItem(datepickerCompetitorsLocalStorageKey)) {
        return {
            date: { from: dayjs().toDate(), to: dayjs().toDate() },
            period: LAST_3_MONTHS
        };
    }

    return JSON.parse(window.localStorage.getItem(datepickerCompetitorsLocalStorageKey));
}
